import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import Container from '~/grid/Container';
import ExtendedGridWrapper from '../../organisms/ExtendedGridWrapper';
import Icon from '../../atoms/Icon';
import { useIntl } from 'react-intl';

const initialHeight = 150;

const animationWayHeight = 75;

const Content = styled.div`
  @keyframes expand {
    0% {
      height: ${initialHeight}px;
    }
    80% {
      height: ${initialHeight + animationWayHeight}px;
    }
    100% {
      height: auto;
    }
  }
  @keyframes collapse {
    0% {
      height: auto;
    }
    80% {
      height: ${initialHeight + animationWayHeight}px;
    }
    100% {
      height: ${initialHeight}px;
    }
  }
  height: ${initialHeight}px;
  ${(props) =>
    props.animationAllowed &&
    css`
      animation: ${props.active ? 'expand' : 'collapse'};
      animation-duration: 0.1s;
      animation-fill-mode: forwards;
    `}
  overflow: hidden;
`;

const Button = styled.div`
  position: relative;
  color: ${(props) => props.theme.color.primary800};
  width: 100%;
  text-align: left;
  margin-top: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: color 0.25s ease-out;

  &:hover {
    color: ${(props) => props.theme.color.cta};
  }

  ${(props) =>
    !props.active &&
    css`
      margin-top: -44px;
      padding: 45px 0 0;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 50%,
        rgba(255, 255, 255, 1) 100%
      );
    `}
`;

const IconWrapper = styled.div`
  transform: ${(props) => (props.active ? 'rotate(-90deg)' : 'rotate(90deg)')};
  width: 13px;
  transform-origin: center;
  margin: -3px 10px 0 0;
`;

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement}
 */
const TeaserIntroMore = ({ children }) => {
  const intl = useIntl();
  const [active, toggleState] = useState(false);
  const [animationAllowed, allowAnimation] = useState(false);
  const containerId = 'initialBenefitsId';

  const handleClick = () => {
    toggleState(!active);
    allowAnimation(true);
    if (active) {
      setTimeout(() => {
        const elmnt = document.getElementById(containerId);
        if (elmnt) {
          elmnt.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <Container id={containerId}>
      <Content active={active} animationAllowed={animationAllowed}>
        <ExtendedGridWrapper>{children}</ExtendedGridWrapper>
      </Content>
      <Button role="button" active={active} onClick={() => handleClick()}>
        <IconWrapper active={active}>
          <Icon icon="ARROW_CTA" />
        </IconWrapper>
        <div>
          {active
            ? intl.formatMessage({
                id: 'teaserIntroMore.showLess',
              })
            : intl.formatMessage({
                id: 'teaserIntroMore.showMore',
              })}
        </div>
      </Button>
    </Container>
  );
};

export default TeaserIntroMore;
